import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';

const initialState = {
    start: dayjs().subtract(1, 'month').date(1).toISOString(),
    end: dayjs().date(1).subtract(1, 'day').toISOString(),
    requestId: 0,
};

export const glassSearchSlice = createSlice({
    name: 'glassSearch',
    initialState,
    reducers: {
        setFilters: (state, action) => {
            const { start, end } = action.payload || {};
            state.start = dayjs(start).toISOString();
            state.end = dayjs(end).toISOString();
        },
        triggerSearch: (state) => {
            state.requestId += 1;
        },
    }
});

// Action creators are generated for each case reducer function
export const { setFilters, triggerSearch } = glassSearchSlice.actions;

export default glassSearchSlice.reducer;